module.exports = __webpack_public_path__ + "src/assets/images/HERO-new-app-modal.svg?e3f8abf2bf92b326c5350484e027cdcf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HERO-new-app-modal.svg
// module id = 977
// module chunks = 1